module.exports = __webpack_public_path__ + "img/20.022e45e3.svg";